<template>
<div class="user_order no-trans" v-loading="loading">
    <div class="order_titles">我的订单</div>
    <div class="user_order_box">
        <div class="order_types">
            <div class="lefts">
                <div class="types" :class="{types_ac:types_ac==item.state}" v-for="(item,index) in type_list" :key="index" @click="handle_type(item)">
                    {{ item.title }}
                </div>
            </div>
            <div class="rights">
                <el-input
                    placeholder="输入商品名称、订单号"
                    v-model="keyword" @keyup.enter.native="handle_seach">
                    <div slot="suffix" class="" @click="handle_seach">
                        <img src="../../../../assets/img/user_info/user_order/seach.png" alt="">
                    </div>
                </el-input>
            </div>
        </div>
        <div class="order_0" v-if="order_list.length==0">
            <img src="@/assets/img/user_info/user_grzx/order_0.png" alt="">
            <div class="texts">暂无待处理订单</div>
        </div>
        <div class="order_list" v-if="order_list.length!=0">
            <div class="order_item" v-for="(item,index) in order_list" :key="index">
                <div class="item_titles">
                    <div class="order_lefts">
                        <div class="order_time">{{ item.created_at }} </div>
                        <div class="order_no">订单号：{{ item.order_sn }}</div>
                    </div>
                    <div class="order_rights">
                        {{ item.status==10?'待付款':'' }}
                        {{ item.status==20?'待服务':'' }}
                        {{ item.status==30?'服务中':'' }}
                        {{ item.status==40?'已结项':'' }}
                        {{ item.status==50?'已评价':'' }}
                    </div>
                </div>
                <div class="order_info">
                    <div class="shop_list">
                        <div class="shop_item" >
                            <div class="shop_left">
                                <div class="shop_img">
                                    <!-- <img src="@/assets/img/index/legal/bg1.png" alt=""> -->
                                     <img v-if="!mobile_view || (item.pro||{}).thumb" :src="(item.pro||{}).thumb" alt="">
                                     <i v-else class="el-icon-document" aria-hidden="true"></i>
                                </div>
                                <div class="shop_title">{{ (item.pro||{}).title }}</div>
                            </div>
                            <div class="shop_right">
                                <div class="shop_price1" v-if="item.jifen_id">{{(item.pro||{}).jifen}}积分+{{(item.pro||{}).money}}元</div>
                                <div class="shop_price1" v-else>{{(item.pro||{}).price}}元</div>
                                <div class="shop_num">X1</div>
                                <div class="shop_price2" v-if="item.jifen_id">{{(item.pro||{}).jifen}}积分+{{(item.pro||{}).money}}元</div>

                                <div class="shop_price2" v-else>{{(item.pro||{}).price}}元</div>
                            </div>
                        </div>
                    </div>
                    <div class="order_btns">
                        <div class="btns_lefts">
                            <div class="text1">
                                共
                                <span>1</span>
                                个商品
                            </div>
                            <div class="text2">
                                合计金额
                                <span v-if="item.jifen_id">{{(item.pro||{}).jifen}}</span>
                                {{ item.jifen_id?'积分':'' }}
                                <span v-if="item.jifen_id">+{{(item.pro||{}).money}}</span>
                                <span v-else> {{ item.price }}</span>
                                元 
                            </div>
                        </div>
                        <div class="btns_right">
                            <div class="btns1" v-if="!mobile_view || item.kaipiao_file" @click="handle_fp(item)">下载发票<span v-if="!mobile_view">{{item.kaipiao_file}}</span></div>
                            <div class="btns1" @click="handle_deitial(item)">订单详情</div>
                            <div class="btns2" @click="handle_pay(item)" v-if="item.status==10">去支付</div>
                            <div class="btns2" @click="handle_end(item)" v-if="item.status==30">确认完成</div>
                            <div class="btns2"  @click="handle_pl(item)" v-if="item.status==40">写评价</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pages_box" v-if="!mobile_view || total > pages.limit">
            <div class="btns" @click="handle_pages(1)">首页</div>
            <site-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.page"
                background
                :page-size="pages.limit"
                layout="prev, pager, next"
                :total="total">
            </site-pagination>
            <div class="btns"  @click="handle_pages(last_page || 1)">尾页</div>
        </div>
    </div>
    <user_order_qx ref="user_order_qx"></user_order_qx>
    
</div>
</template>
<script>
import { mapState} from 'vuex'
import user_order_qx from '@/components/user_order/user_order_qx.vue'//律所
 
 

export default {
    components: {
        user_order_qx,
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword:'',//
            types_ac:0,
            type_list:[
                {
                    title:'全部服务订单',
                    state:0,
                },
                {
                    title:'待付款',
                    state:10,
                },
                {
                    title:'待服务',
                    state:20,
                },
                {
                    title:'服务中',
                    state:30,
                },
                {
                    title:'已结项',
                    state:40,
                },
                {
                    title:'已评价',
                    state:50,
                },
                
            ],
            order_list:[],

            total:100,
            last_page:1,
            pages:{
                page:1,
                limit:10,
            },
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        if(this.$route.query.types_ac){
            this.types_ac=this.$route.query.types_ac
        }
        this.get_list()
    },
    methods: {
        handle_type(item){
            this.types_ac=item.state   
            this.pages.page=1
            this.get_list()

        },
        handle_seach(){
            console.log('点击搜索')
            this.pages.page=1
            this.get_list()
        },
        handleSizeChange(e){
            console.log('条数',e)            
        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()
        },
        get_list(){
            this.loading = true
            this.$api("myOrderList", {
                status:this.types_ac,
                ...this.pages,
                is_over:1
			}, "get").then((res) => {
                this.loading = false
                console.log('我的订单列表',res)
                if (res.code == 1) {
                    this.order_list=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_fp(item){
            console.log('发票',item)
        },
        handle_deitial(item){
            this.$router.push({
                path:'/user_order/order_detial',
                query:{
                    id:item.id
                }
            })
        },
        handle_pay(item){
            this.$router.push({
                path:'/Legal_pay',
                query:{
                    order_id:item.id,
                    pro_id:item.pro_id
                }
            })
        },
        handle_end(item){
            this.$confirm('确定完成服务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handle_end2(item)
            }).catch(() => {
               
            });
        },
        handle_end2(item){
            this.loading = true
            this.$api("finishOrder", {
               id:item.id
             
			}, "post").then((res) => {
                this.loading = false
                console.log('我的订单列表',res)
                if (res.code == 1) {
                    alertSucc('服务完成')
                   this.get_list()
                } else {
                    alertErr(res.msg)
                }
            });
        },

        handle_pl(item){
            this.$router.push({
                path:'/user_order/order_pj',
                query:{
                    id:item.id
                }
            })
        },

    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        padding: 24px 32px;    
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .order_types{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .types{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    padding-bottom: 12px;
                    margin-right: 48px;
                    border-bottom: 4px solid #FFFFFF;
                    cursor: pointer;
                    &:hover{
                        border-bottom: 4px solid #377CFD;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                    }
                }
                .types_ac{
                    border-bottom: 4px solid #377CFD;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
            .rights{
                /deep/.el-input{
                    width: 282px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    // border: 1px solid #B8C4D1;
                    .el-input__inner{
                        width: 282px;
                        height: 32px;
                    }
                    .el-input__suffix{
                        display: flex;
                        // line-height: 32px;
                        margin-right: 3px;
                        align-items: center;
                        cursor: pointer;
                        img{
                            width: 18px;
                        }
                    }
                }
            }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .order_list{
            padding: 32px 0;
            .order_item{
                // width: 1132px;
                min-height: 260px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                margin-bottom: 10px;
                .item_titles{
                    // width: 1132px;
                    height: 44px;
                    background: #F5F5F5;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #E5E5E5;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding:0 24px ;
                    .order_lefts{
                        display: flex;
                        align-items: center;
                        .order_time{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                            margin-right: 20px;
                        }
                        .order_no{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                        }
                    }
                    .order_rights{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;

                    }
                }
                .order_info{
                    padding:0 24px;
                    padding-top: 24px;
                    .shop_list{
                        
                        border-bottom: 1px solid #E5E5E5;
                        .shop_item{
                            margin-bottom: 24px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .shop_left{
                                display: flex;
                                align-items: center;
                                .shop_img{
                                    width: 104px;
                                    height: 104px;
                                    img{
                                        width: 104px;
                                        height: 104px;
                                    }
                                }
                                .shop_title{
                                    padding-left: 24px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;
                                }
                            }
                            .shop_right{
                                display: flex;
                                align-items: center;
                                .shop_price1{
                                    width: 150px;
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;

                                }
                                .shop_num{
                                    width: 100px;
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;
                                }
                                .shop_price2{
                                    width: 150px;
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;


                                }
                            }
                        }
                    }
                    .order_btns{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 64px;
                        .btns_lefts{
                            display: flex;
                            align-items: center;
                            .text1{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                span{
                                    color: #377CFD;
                                    font-weight: bold;
                                }
                            }
                            .text2{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                margin-left: 20px;
                                span{
                                    color: #377CFD;
                                    font-weight: bold;

                                }
                            }
                        }
                        .btns_right{
                            display: flex;
                            align-items: center;
                            .btns1{
                                width: 104px;
                                height: 32px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                line-height: 32px;
                                text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                                cursor: pointer;
                                margin-left: 10px;

                            }   
                            .btns2{
                                width: 104px;
                                height: 32px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                text-align: center;
                                line-height: 32px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;
                                margin-left: 10px;
                            }

                        }
                    }
                    

                }
            }
        }
        .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
    }


}
</style>
<style scoped lang="less">
@import "../../../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .user_order.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_order.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .user_order.no-trans .user_order_box {
        padding: 16px 16px;
        margin-top: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .user_order.no-trans .user_order_box .order_types {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types {
        font-size: 14px;
        padding-bottom: 12px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types_ac {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__inner {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-right: 3px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix img {
        width: 18px;
    }
    .user_order.no-trans .user_order_box .order_0 {
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_0 img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_0 .texts {
        padding-top: 16px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list {
        padding: 16px 0;
    }
    .user_order.no-trans .user_order_box .order_list .order_item {
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 10px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles {
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        min-height: 44px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_lefts .order_time {
        font-size: 14px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_lefts .order_no {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_rights {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info {
        padding: 0 16px;
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item {
        margin-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_left {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_left .shop_img {
        width: 104px;
        min-height: 0;
        height: auto;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_left .shop_img img {
        width: 104px;
        min-height: 0;
        height: auto;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_left .shop_title {
        padding-left: 16px;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_right {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_right .shop_price1 {
        width: 150px;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_right .shop_num {
        width: 100px;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_right .shop_price2 {
        width: 150px;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        height: auto;
        min-height: 44px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_lefts .text1 {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_lefts .text2 {
        font-size: 14px;
        margin-left: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_right {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_right .btns1 {
        width: 104px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        margin-left: 10px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_right .btns2 {
        width: 104px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        margin-left: 10px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_order.no-trans .user_order_box .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
@media (max-width: 1024px) {
    .user_order.no-trans .user_order_box {
        .order_types .rights { width: 100%; }
        .order_list .order_item .item_titles { height: auto; padding: 12px; }
        .order_list .order_item .order_info { padding: 16px 12px; }
        .order_list .order_item .order_info .order_btns { height: auto; padding: 16px 0 0; gap: 12px; }
        .order_list .order_item .order_info .order_btns .btns_lefts { width: 100%; }
        .order_list .order_item .order_info .order_btns .btns_right { width: 100%; gap: 8px; }
        .order_list .order_item .order_info .order_btns .btns_right > div { margin: 0; flex: 1 1 100px; }
        .pages_box { margin-top: 16px; justify-content: center; }
    }
}

@media (max-width: 1024px) {
    .user_order.no-trans { .mobile-order-list(); }
}
@media (max-width: 1024px) {
    .user_order.no-trans {
        background: #fff;
        .order_titles { display: flex; align-items: center; height: auto; min-height: 48px; padding: 12px 16px; font-size: 18px; line-height: 26px; font-weight: 600; border: 0; }
        .user_order_box {
            margin: 0; padding: 0 16px 20px;
            .order_types {
                display: block; padding: 0; border: 0;
                .lefts { display: flex; flex-wrap: nowrap; gap: 0; width: 100%; overflow-x: auto; border-bottom: 1px solid #e5eaf1; overscroll-behavior-x: contain; }
                .lefts .types { flex: 0 0 auto; display: flex; align-items: center; min-height: 48px; padding: 10px 12px; margin: 0; font-size: 14px; line-height: 24px; white-space: nowrap; border-bottom: 2px solid transparent; }
                .lefts .types_ac { color: #377cfd; border-bottom-color: #377cfd; font-weight: 600; }
                .rights { margin: 14px 0 18px; }
                .rights /deep/ .el-input { height: 44px; }
                .rights /deep/ .el-input .el-input__inner { height: 44px; padding: 0 48px 0 12px; font-size: 16px; border-color: #dfe5ee; background: #f8fafc; }
                .rights /deep/ .el-input .el-input__suffix { top: 0; right: 0; width: 44px; height: 44px; margin: 0; }
                .rights /deep/ .el-input .el-input__suffix-inner, .rights /deep/ .el-input .el-input__suffix-inner > div { display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; cursor: pointer; }
            }
            .order_list {
                padding: 0;
                .order_item {
                    margin: 0 0 16px; border: 1px solid #e5eaf1; border-radius: 6px; overflow: hidden;
                    .item_titles {
                        display: flex; flex-wrap: nowrap; align-items: flex-start; gap: 10px; padding: 12px; background: #f5f7fb;
                        border: 0;
                        .order_lefts { display: block; flex: 1; min-width: 0; }
                        .order_time, .order_no { margin: 0; font-size: 13px; line-height: 22px; overflow-wrap: anywhere; color: #748092; }
                        .order_rights { flex-shrink: 0; font-size: 13px; line-height: 22px; color: #377cfd; }
                    }
                    .order_info {
                        padding: 14px 12px;
                        .shop_list { padding: 0; border: 0; }
                        .shop_list .shop_item {
                            display: block; padding: 0;
                            .shop_left { display: flex; align-items: flex-start; gap: 10px; width: 100%; }
                            .shop_left .shop_img { display: flex; align-items: center; justify-content: center; flex: 0 0 64px; width: 64px; height: 64px; border-radius: 4px; overflow: hidden; background: #f3f6fa; }
                            .shop_left .shop_img i { font-size: 28px; color: #9aacc5; }
                            .shop_left .shop_img img { display: block; width: 64px; height: 64px; object-fit: cover; }
                            .shop_left .shop_title { min-width: 0; flex: 1; padding: 0; font-size: 15px; line-height: 24px; overflow-wrap: anywhere; }
                            .shop_right { display: flex; justify-content: flex-end; flex-wrap: wrap; width: 100%; gap: 6px 12px; padding: 8px 0 0; }
                            .shop_right .shop_price1, .shop_right .shop_num { width: auto; margin: 0; font-size: 13px; line-height: 22px; color: #748092; overflow-wrap: anywhere; }
                            .shop_right .shop_price2 { display: none; }
                        }
                        .order_btns {
                            display: block; padding: 12px 0 0; margin-top: 12px; border-top: 1px solid #edf0f5;
                            .btns_lefts { display: flex; flex-wrap: wrap; align-items: baseline; justify-content: space-between; gap: 4px 8px; }
                            .btns_lefts .text1, .btns_lefts .text2 { margin: 0; font-size: 13px; line-height: 24px; color: #748092; overflow-wrap: anywhere; }
                            .btns_lefts .text2 span { font-size: 19px; line-height: 28px; }
                            .btns_right { display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
                            .btns_right > .btns1, .btns_right > .btns2 { flex: 0 1 auto; width: auto; min-width: 88px; min-height: 44px; margin: 0; padding: 9px 12px; font-size: 14px; line-height: 24px; border-radius: 4px; }
                        }
                    }
                }
            }
            .order_0 { padding: 32px 0; }
            .order_0 img { width: 112px; height: 96px; object-fit: contain; }
            .order_0 .texts { font-size: 14px; line-height: 24px; color: #87909d; }
            .pages_box { padding-top: 8px; }
            .pages_box > .btns { display: none; }
        }
    }
}
</style>
